import { render, staticRenderFns } from "./strip.vue?vue&type=template&id=ade5ccbe"
import script from "./strip.vue?vue&type=script&lang=js"
export * from "./strip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports